<nav aria-label="breadcrumb" (click)="paymentShowToggle()">
    <ol class="breadcrumb section-header-breadcrumb">
      <li class="breadcrumb-item active" aria-current="page">
        <div class="breadcrumb-content">
        <i class="fa fa-plus breadcrumb-icon"  *ngIf="!isPaymentShow"></i>
        <i class="fa fa-minus breadcrumb-icon"  *ngIf="isPaymentShow"></i>
        <p class="h5 breadcrumb-text"> Add Payment</p>
      </div></li>
    </ol>
  </nav>
  <div *ngIf = "isPaymentShow">
<form [formGroup]="paymentForm" (ngSubmit)="onPaymentSubmit()">
    <div class="row g-3">
      <div class="mb-3 col">
        <label for="paymentAmount">Payment Amount</label>
        <input type="number" formControlName="paymentAmount" class="form-control" [ngClass]="{ 'is-invalid': submitted && pmntForm.paymentAmount.errors }" />
        <div *ngIf="submitted && pmntForm.paymentAmount.errors" class="invalid-feedback">
            <div *ngIf="pmntForm.paymentAmount.errors.required">Payment Amount is required</div>
        </div>
    </div>
    <div class="mb-3 col">
            <label for="comments">Comments</label>
            <input type="text" formControlName="comments" class="form-control" [ngClass]="{ 'is-invalid': submitted && pmntForm.comments.errors }" />
            <div *ngIf="submitted && pmntForm.comments.errors" class="invalid-feedback">
                <div *ngIf="pmntForm.comments.errors.required">Comments is required</div>
            </div>
        </div>
    </div>
    <div class="row g-3">
      <div class="mb-3 col">
        <div class="mb-3 form-check">
          <input type="checkbox" formControlName="acceptTerms" id="acceptTerms" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && pmntForm.acceptTerms.errors }" />
          <label for="acceptTerms" class="form-check-label">I agree with the <a href="https://allianceassure.com/terms-conditions/"> Terms & Conditions </a> by proceeding with this payment</label>
          <div *ngIf="submitted && pmntForm.acceptTerms.errors" class="invalid-feedback">Accept Ts & Cs is required</div>
      </div>

      </div>
    </div>
    <div class="mb-3">
      <button [disabled]="loading" class="btn btn-primary me-2">
          <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
          Pay
      </button>
      <button class="btn btn-secondary" type="reset" (click)="onReset()">
        Refresh Page
    </button>
  </div>
  <div class="mb-3">
    <div class="alert alert-success" role="alert" *ngIf="isBalanceUpdated">
      <i class="fa fa-check-circle me-1"></i> Balance Updated! Please refresh page to see new balance.
    </div>
</div>

</form>
</div>

